// vendor stuff
import './bootstrap-validator';

// our stuff
import inboxSocialIntergration from './inbox-social-integration';
import signupEvents from './signup-events';
import validationBusinessHandler from './validation-business-handler';
import validationPersonalHandler from './validation-personal-handler';
import { debounce } from 'underscore';
import emailCheck from './email-check';
import emailValidationAlert from './email-validation-alert';
import { debounceTimeout } from './config';
import multiStepForm from './multi-step-form';
import signupValidator from './signup-validator';
import passwordStrength from '../modules/password-strength';

const initialize = (type) => {
    passwordStrength();

    const signupEventsInstance = new signupEvents();

    const inboxSocial = new inboxSocialIntergration('btn-social-provider');
    inboxSocial.registerRedirectQueryDataHandler();
    inboxSocial.registerLoginClickHandler();

    signupEventsInstance.initializeTabFieldsActions();
    signupEventsInstance.formPagesReloadHandler();

    if (type === 'personal') {
        validationPersonalHandler(inboxSocial);
    }

    if (type === 'business') {
        validationBusinessHandler(signupEventsInstance, inboxSocial);
    }

    // email check start for personal and admin
    window.debounceIsFetching = false;
    window.debounceCache = {};
    window.isEmailAvailableCache = {};
    window.debounceCounter = 1;
    window.debounceId = 0;

    document.addEventListener('input', function (event) {
        if (!event.target.matches('[name="g-recaptcha-response"],[name="h-captcha-response"],[name="cf-turnstile-response"]')) return;
        // console.log('detected captcha validation. we trigger username revalidation if it was previously not valid because of captcha');
        $('#username,#domain,input[name=backup_email]').trigger('input');
    }, false);

    $('body').on('input focusout.bs.validator', '#username,input[name=backup_email]', debounce((e) => {
        console.log('email validator started with event: '+e.type);
        console.log('current tab: '+window.current_tab);
        if (e.type === 'focusout') {
            console.log('email input not focused, skipping validation');
            return;
        }

        const $usernameEl = $(e.target);
        const isEmailAvailableCheckType = $usernameEl.data('isemailavailabletype');

        const enteredValue = $usernameEl.val();
        let emailToCheck = enteredValue;
        if (isEmailAvailableCheckType === 'personal') {
            emailToCheck += '@inbox.eu';
        }

        window.debounceId = window.debounceId+1;

        //if we are the only one on event creation and later newer event appears- remove itself
        if (window.debounceIsFetching) {
            const debounceInterval = setInterval(() => {
                if (!window.debounceIsFetching) {
                    //console.log('no active ajax request fetching, exit setInterval');
                    clearInterval(debounceInterval);
                    return;
                }
                //if more than one is waiting- drop older event to save on ajaxrequests
                if (window.debounceCounter > window.debounceId) {
                    window.debounceCounter = window.debounceCounter-1;
                    clearInterval(debounceInterval);
                    return 2;
                }
            }, 10);
        }

        const emailCheckInstance = new emailCheck(emailToCheck, isEmailAvailableCheckType);

        const continueBtn = $('button[type="submit"][data-next_tab]:visible');

        if (!emailCheckInstance.isValid()) {
            console.log('email is not valid');
            continueBtn.attr('disabled', 'disabled');
            emailValidationAlert('warning');
            return;
        }

        emailCheckInstance.isAvailable((isAvailable) => {
            console.log('email isAvailable: '+isAvailable);

            if (isAvailable) {
                emailValidationAlert('success');
                inboxSocial.addCustomQueryParam('username', enteredValue);
                continueBtn.removeAttr('disabled');
                // $usernameEl.removeData('bs.validator.errors');
                $usernameEl.data('bs.validator.errors', []);
            } else {
                emailValidationAlert('danger');

                $usernameEl.data('bs.validator.errors', ['email not available']);
                if (
                    window.current_tab === 'signup_business_social_connected' ||
                    window.current_tab === 'signup_personal_social_connected'
                ) {
                    //email validation will be done on next step
                    console.log('email validator: do not disable continue button as we are on social connected page');
                    return;
                }
                continueBtn.attr('disabled', 'disabled');
            }

            $usernameEl.attr('data-validate', 'false');
            $usernameEl.data('validate', 'false');
        }, e.type);
    }, debounceTimeout));
    // email check end

    //email already auto-filled (social login for example)
    const adminEmailEl = document.querySelector('input[name=backup_email]');
    if (adminEmailEl && adminEmailEl.value) {
        console.log('triggered email stuff');
        adminEmailEl.dispatchEvent(new Event('input', {bubbles:true}));
    }

    window.onpopstate = (event) => {
        // if (!document.location.hash) {
        //     return;
        // }
        console.log('current signup tab: '+window.current_tab);

        if (!window.current_tab) {
            console.log('no current signup tab');
            return;
        }
        // trim # from location hash
        const elementId = window.current_tab;
        // switch tab only if element exists in page
        if (document.getElementById(elementId)) {
            console.log('tab switch started');

            multiStepForm.switchToTab(elementId, event);
        }
    };

    const resendBtnId = 'resend-verification-code';
    const backupEmailInputId = 'email';
    if (document.getElementById(resendBtnId)) {
        signupEventsInstance.registerResendEmailVerificationHandler(resendBtnId, backupEmailInputId, type);
    }

    // form validation start
    // override input to validate to only those on current tab in multi tab signup forms
    $.fn.validator.Constructor.INPUT_SELECTOR = '.form_tab:visible :input:not([type="hidden"], [type="submit"], [type="reset"], button)';

    const $signupForm = $('.signup-form');
    if ($signupForm.length > 0) {
        new signupValidator($signupForm, type);
    }
    // form validation end
};

export default initialize;
